import { IconButton, Popover, QuestionCircleIcon, Text } from '@libs/ui/ds'
import { PopoverDropdown } from '@libs/ui/ds/lib/components/overlays/Popover/base/compound/PopoverDropdown'
import { PopoverTarget } from '@libs/ui/ds/lib/components/overlays/Popover/base/compound/PopoverTarget'
import { cva } from 'class-variance-authority'
import type { FC } from 'react'

import type { InformationPopoverProps } from './InformationPopover.types'

const labelCVA = {
  root: cva([
    'overflow-auto whitespace-pre-line text-xs font-normal text-neutral-900'
  ])
}

export const InformationPopover: FC<InformationPopoverProps> = ({
  content,
  ...other
}) => {
  return (
    <Popover closeOnClickOutside trigger='hover' {...other}>
      <PopoverTarget>
        <IconButton
          type='button'
          icon={<QuestionCircleIcon />}
          intent='neutral-dark'
          size='s'
          variant='tertiary'
          className='ml-1'
        />
      </PopoverTarget>
      <PopoverDropdown>
        <Text as='span' className={labelCVA.root()}>
          {content}
        </Text>
      </PopoverDropdown>
    </Popover>
  )
}

export type { InformationPopoverProps } from './InformationPopover.types'
